export const BADGE_LEVELS = [
  { level: 1, name: "Health Explorer", min: 0, color: "#38BDF8" },
  { level: 2, name: "Healthy Starter", min: 500, color: "#22D3EE" },
  { level: 3, name: "Health Champion", min: 1500, color: "#10B981" },
  { level: 4, name: "Wellness Warrior", min: 3500, color: "#4ADE80" },
  { level: 5, name: "KOI Hero", min: 6500, color: "#FACC15" },
  { level: 6, name: "Health Ambassador", min: 10000, color: "#F59E0B" },
  { level: 7, name: "School Doctor Champion", min: 15000, color: "#F97316" },
  { level: 8, name: "KOI Legend", min: 22000, color: "#8B5CF6" },
];

export function levelFor(points = 0) {
  let current = BADGE_LEVELS[0];
  let next = BADGE_LEVELS[1] ?? null;
  BADGE_LEVELS.forEach((lv, i) => {
    if (points >= lv.min) {
      current = lv;
      next = BADGE_LEVELS[i + 1] ?? null;
    }
  });
  return {
    current,
    next,
    points,
    points_to_next: next ? Math.max(next.min - points, 0) : 0,
    stars: Math.max(1, Math.min(5, Math.ceil(current.level / 2) + 1)),
  };
}
